// extracted by mini-css-extract-plugin
export default {"page":"O4IVeY8N","main":"Dz9wBD6K","mainWrapper":"qRBwod4j","mainTitle":"PnyLjuDB","title":"RalLV96U","tabsButtonWrapper":"KbHReOYS","selectorWrapper":"jMTGDvDn","buttonTab":"CTLhHwzP","activeTab":"mkFfTXmL","backToGameButton":"FJ7ZV6kW","contentWrapper":"cIUcVxpQ","cardsWrapper":"yeb8yuW6","goodCard":"XL7BgBis","disableCard":"jbG7ozUs","requiredLevelTablet":"SjtVUyvL","discount":"N69kkrVa","visible":"Y6OcJkjM"};
    if(module.hot) {
      // 1721069998934
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  